import React, { useState } from 'react'
import AssetGroupsTree from '../../AssetGroups/AssetGroupsTree'
import styled from 'styled-components'
import { PenIcon } from '../../Icons/PenIcon'
import { useTranslation } from 'react-i18next'
import { APIEndpoints } from '../../../utils/api/apiConfig'
import apiClient from '../../../utils/api/apiClient'
import { useNavigate } from 'react-router-dom'
import { emptyGuid } from '../../../utils/emptyGuid'
import ModalComponent2 from '../../Modals/ModalComponent2'
import { DeleteIcon } from '../../Icons/DeleteIcon'
import useStores from '../../../stores/useStore'
import MediaQuery from 'react-responsive'
import MoreOptionsButton from '../../Buttons/MoreOptionsButton'

const StyledWrapper = styled.div`

  @media screen and (min-width: 1080px) {
    max-width: calc(100% - 480px);
    min-width: 600px;
  }

  .search-wrapper{
    padding-left: 0;
    padding-right: 0;
  }

`

const EditAssetGroupsTree = ({ onOpen }) => {
  const { t } = useTranslation()
  const [actionSelect, setActionSelect] = useState("")
  const [selectedGroup, setSelectedGroup] = useState({})
  const [btn1Loading, setBtn1Loading] = useState(false)
  const [btn2Loading, setBtn2Loading] = useState(false)
  const [error, setError] = useState("")
  const {assetGroupStore} = useStores()
  const navigate = useNavigate();

  const reloadGroupTree = () => {
    assetGroupStore.resetGroups()
    assetGroupStore.getGroups(emptyGuid)
  }

  // delete function with two arguments id and recurisvely
  const deleteGroupItem = (recursively = false) => {
    recursively ? setBtn2Loading(true) : setBtn1Loading(true)
    apiClient.deleteJson(APIEndpoints.assetGroupAdmin(selectedGroup.id).group, { recursively })
      .then(() => {
        reloadGroupTree()
        setActionSelect("")
      }).catch((error) => {
        setError(error.message)
      }).finally(() => {
        setBtn1Loading(false)
        setBtn2Loading(false)
      })
  }

  const openGroupInfo = group => {
    setSelectedGroup(group)
  }
  const openDeleteModal = (group) => {
    setSelectedGroup(group)
    setActionSelect("delete")
  }

  const getContextMenuOptions = (group) => [
    {
      option: 'edit',
      optionText: t('edit'),
      optionIcon: <PenIcon />,
      onOptionSelect: () => navigate(`/assetGroupsAdministration/edit/${group.id}#general`)
    },
    {
      option: 'delete',
      optionText: t('deleteButton'),
      optionIcon: <DeleteIcon />,
      onOptionSelect: () => openDeleteModal(group)
    },
  ]
  const renderExtraItemContent = (group) => (
    <MediaQuery maxWidth={1499}>
      <div className="action-buttons"  >
        <MoreOptionsButton options={getContextMenuOptions(group)} />
      </div>
    </MediaQuery>
  )

  return (
    <StyledWrapper>
      <AssetGroupsTree
        withSearch
        onClick={openGroupInfo}
        isClickable={() => true}
        getContextMenuOptions={getContextMenuOptions}
        renderExtraItemContent={renderExtraItemContent}
      />
      {actionSelect === "delete" &&
        <ModalComponent2
          ModalTitle={t('assetGroups:deleteAssetGroup')}
          BodyPart1={t('assetGroups:deleteBody')}
          bodyStyle="alert alert-danger"
          functionCancel={() => setActionSelect("")}
          showButton2={selectedGroup.hasChildren}
          button1Text={t('delete')}
          button1Function={() => { deleteGroupItem() }}
          button1Loading={btn1Loading}
          button1Variant="danger"
          button2Text={t('assetGroups:deleteRecursively')}
          button2Function={() => { deleteGroupItem(true) }}
          button2Loading={btn2Loading}
          button2Variant="danger"
          error={error.message}
        />
      }
    </StyledWrapper>
  )
}

export default EditAssetGroupsTree
